// Событие лида для Telegram Pixel. Сам пиксель инициализируется в шаблоне
// (partials/telegram-pixel.blade.php), сюда вынесена только отправка события:
// оно отправляется по успешной отправке формы «Submit request», а не на загрузке
// страницы, иначе конверсией считался бы каждый просмотр страницы.
const LEAD_EVENT = 'EVUoToG0-dzXaM7lS';

export function trackTelegramLead() {
  // tgp объявляется синхронно вместе с инициализацией и до загрузки pixel.js
  // копит вызовы в очереди, поэтому дополнительного ожидания не нужно.
  // Опциональный вызов — на страницах без пикселя (или при блокировке
  // скрипта адблоком) отправка формы не должна падать.
  window.tgp?.('event', LEAD_EVENT);
}
